<div class="display-flex" style="width: 100%;">
  <div class="display-flex display-layout-column" style="width: 100%;">

    <div class="search-field display-layout-column layout-gap-15">
      <div class="display-layout-column justify-content-center align-items-start">
        <div class="display-layout-row layout-gap-10 layout-align-center-center" [formGroup]="searchForm">
          <mat-form-field>
            <mat-label>Search</mat-label>
            <input formControlName="filter" matInput (keyup)="applyFilter()" />
            <mat-icon matSuffix>search </mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
      <!-- Arrow Column -->
      <ng-container matColumnDef="arrow">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="firstLine">
          <div class="display-layout-row layout-align-center-center layout-gap-10">
            <div [ngClass]="(element.newMessages?.length > 0) ? 'new-messages' : 'not-new-messages'"></div>
            <button mat-icon-button (click)="toggleRow(element); $event.stopPropagation()">
              <mat-icon>
                {{ detailData === element ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </button>
            @if (messagesLoading && collapsedTable.id === element.id) {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </div>
        </td>
      </ng-container>

      <!-- Request ID Column -->
      <ng-container matColumnDef="requestId">
        <th mat-header-cell *matHeaderCellDef>Request Id</th>
        <td mat-cell *matCellDef="let element" class="firstLine">
          <div class="display-layout-row layout-align-center-center">
            <div [matTooltip]="element.requestID">
              {{ getShortenedRequestId(element.requestID) }}
            </div>
            <button [cdkCopyToClipboard]="element.requestID"
                    matTooltip="Copy RequestID"
                    mat-icon-button
                    (click)="$event.stopPropagation()">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Customer Info Column -->
      <ng-container matColumnDef="customerInfo">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let element">
          <div class="display-layout-column">
            <div class="firstLine">{{ element.customer?.companyName }}</div>
            <div class="secondLine">{{ element.customer?.email }}</div>
          </div>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="requestStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">
          <mat-chip-set>
            <mat-chip [ngClass]="getStatusStyle(element.requestStatus)">
              {{ getStatus(element.requestStatus) }}
            </mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Destination Column -->
      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef>Destination</th>
        <td mat-cell *matCellDef="let element">
          <div class="display-layout-column">
            <div class="firstLine">{{ element.finalDestination }}</div>
            <div class="secondLine">{{ element.availableExOrigin | date: 'dd/MM/yyyy' }}</div>
          </div>
        </td>
      </ng-container>

      <!-- Package Info Column -->
      <ng-container matColumnDef="packageInfo">
        <th mat-header-cell *matHeaderCellDef>Package Info</th>
        <td mat-cell *matCellDef="let element">
          <div class="firstLine">
            {{ element.numberOfParcels }} / {{ element.chargeableWeight }} kg
          </div>
        </td>
      </ng-container>

      <!-- Actions & View Details -->
      <ng-container matColumnDef="viewDetails">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-stroked-button [routerLink]="['/requests', element.id]">
            View Details
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = dataIndex">
          <button [matMenuTriggerFor]="menu" mat-icon-button (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="deleteRequest(row, i)">Delete</button>
            <button mat-menu-item (click)="closeRequest(row)">
              {{ row.closed ? "Open Request" : "Close Request" }}
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- Expanded Detail Row -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div class="example-element-detail"
               [@detailExpand]="element === detailData ? 'expanded' : 'collapsed'">

            @if (element === detailData && messageRequest?.messages) {
              <table class="detailTable" mat-table [dataSource]="messageRequest.messages">
                <ng-container matColumnDef="sendDate">
                  <th mat-header-cell *matHeaderCellDef>Send Date</th>
                  <td mat-cell *matCellDef="let msg">{{ msg.sentDateTime | date: 'dd/MM/yyyy, H:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="receivedDate">
                  <th mat-header-cell *matHeaderCellDef>Received Date</th>
                  <td mat-cell *matCellDef="let msg">{{ msg.receivedDateTime | date: 'dd/MM/yyyy H:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="receivedFrom">
                  <th mat-header-cell *matHeaderCellDef>From</th>
                  <td mat-cell *matCellDef="let msg">{{ msg.from?.emailAddress?.address }}</td>
                </ng-container>

                <ng-container matColumnDef="sendTo">
                  <th mat-header-cell *matHeaderCellDef>To</th>
                  <td mat-cell *matCellDef="let msg">{{ msg.toRecipients[0]?.emailAddress?.address }}</td>
                </ng-container>

                <ng-container matColumnDef="subject">
                  <th mat-header-cell *matHeaderCellDef>Subject</th>
                  <td mat-cell *matCellDef="let msg">{{ msg.subject }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedDetailColumns"></tr>
                <tr mat-row *matRowDef="let msgRow; columns: displayedDetailColumns"></tr>
              </table>
            } @else if (element === detailData && messagesLoading) {
              <div class="p-20 display-layout-row layout-align-center-center">
                <mat-spinner [diameter]="40"></mat-spinner>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns"
          class="example-element-row"
          [class.example-expanded-row]="detailData === element"
          (click)="toggleRow(element)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

      <tr class="mat-row no-data-found" *matNoDataRow>
        No data matching the filter "{{ searchForm.get('filter')?.value }}"
      </tr>
    </table>

    <div class="display-layout-row justify-content-end align-items-center">
      <div>@if (paginationSpinnerStarted) {
        <app-paginator-spinner></app-paginator-spinner>
      }</div>

      <mat-paginator #paginator (page)="pageChangeEvent($event)" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
        showFirstLastButtons [length]="resultsLength">
      </mat-paginator>
    </div>

  </div>

</div>
